export type ReadReceiptGateState = {
  activeTopicId: string | null
  composerAutoFocus: boolean | null
  enteredScope: boolean
  hasUnread: boolean
  isGroupRoot: boolean
  markReadPending: boolean
  messagesFetching: boolean
  messagesLoaded: boolean
  sawNewLatestMessage: boolean
  sawNewMessages: boolean
  topicKnown: boolean
  topicsLoaded: boolean
}

export function readReceiptReady(state: ReadReceiptGateState): boolean {
  if (state.isGroupRoot) return true
  if (state.activeTopicId) {
    return state.topicsLoaded && state.topicKnown
  }
  if (state.composerAutoFocus === null) return false
  if (!state.messagesLoaded || state.messagesFetching) return false
  return true
}

export function shouldDispatchReadReceipt(state: ReadReceiptGateState): boolean {
  if (!readReceiptReady(state)) return false
  if (state.markReadPending) return false
  return (
    state.enteredScope
    || state.sawNewMessages
    || state.sawNewLatestMessage
    || state.hasUnread
  )
}
